import React, { useEffect, useState } from "react";

import styled from "styled-components";
import { ReactComponent as FrameSvg } from "images/svg/phoneFrame.svg";

interface IProps {
  width: string;
  mWidth: string;
  mHeight: string;
  height: string;
  video?: string;
  image?: string;
  center?: boolean;
}
const PhoneFrame = ({
  width,
  height,
  mHeight,
  mWidth,
  image,
  video,
  center
}: IProps) => {
  return (
    <Container
      width={width}
      height={height}
      mHeight={mHeight}
      mWidth={mWidth}
      style={{ border: center ? " 1px solid #fea101" : "" }}
    >
      <SvgContainer>
        <FrameSvg width={"100%"} height={"100%"} />
      </SvgContainer>
      {image && <Image src={image} alt="phone-image" />}

      {video && (
        <Video autoPlay muted playsInline loop>
          <source src={video} type="video/mp4" />
          Your browser does not support the video tag.
        </Video>
      )}
    </Container>
  );
};

export default PhoneFrame;

interface IContainer {
  width: string;
  height: string;
  mHeight: string;
  mWidth: string;
}
const Container = styled.div<IContainer>`
  width: ${(props) => (props.width ? props.width : "15rem")};
  height: ${(props) => (props.height ? props.height : "30rem")};
  position: relative;
  border-radius: 0.8rem;
  overflow: hidden;
  @media only screen and (max-width: 769px) {
    width: ${(props) => (props.mWidth ? props.mWidth : "15rem")};
    height: ${(props) => (props.mHeight ? props.mHeight : "30rem")};
  }
`;
const SvgContainer = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
`;

const Image = styled.img`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;
const Video = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
